import {
  BodyText,
  HeadingText,
  large,
  medium,
  small,
} from '@unmind/design-system-components-web';
import { Nova } from 'icons';
import { rem } from 'polished';
import { css, styled } from 'styles';

export const ChatbotBannerContainer = styled.div`
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${medium(css`
    padding: ${rem(24)} ${rem(100)} ${rem(0)} ${rem(100)};
  `)}

  ${large(css`
    padding: ${rem(24)} ${rem(140)} ${rem(0)} ${rem(140)};
  `)}
`;

export const ChatbotBannerTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${rem(10)};
  margin-bottom: ${rem(20)};

  ${small(css`
    flex-direction: row;
    gap: 0;
    margin-bottom: ${rem(40)};
  `)}
`;

export const ChatbotBannerTitle = styled(HeadingText).attrs(({ theme }) => ({
  sizes: [
    theme.typography.fontSizes.fontSize24,
    theme.typography.fontSizes.fontSize26,
  ],
  weight: theme.typography.fontWeights.semiBold,
  fontFamily: theme.typography.fontFamilies.Inter,
  level: 1,
  accessibilityAutoFocus: true,
}))`
  text-align: center;
`;

export const ChatbotInputContainer = styled.div`
  width: 100%;
  margin-bottom: ${rem(24)};
`;

export const AssistantIcon = styled(Nova)`
  width: ${rem(24)};
  height: ${rem(24)};
  margin-right: ${rem(10)};
`;

export const ConversationStartersContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(8)};
  justify-content: center;
`;

export const ConversationStarter = styled.button`
  border-radius: ${rem(100)};
  background-color: ${({ theme }) => theme.colors.background.card};
  padding: ${rem(5)} ${rem(10)};
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
  display: flex;
  align-items: center;
  gap: ${rem(4)};

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.cardHover};
  }
`;

export const ConversationStarterText = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize12],
  weight: theme.typography.fontWeights.medium,
  color: theme.colors.text.primary,
}))``;

export const ConversationStarterEmoji = styled.span``;
